import React, { useState, useEffect } from "react";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar.svg";
import { ReactComponent as TrashIcon } from "../../../../assets/icons/Delete.svg";
import { ReactComponent as PencilIcon } from "../../../../assets/icons/PencilAlt.svg";
import moment from "moment-timezone";
import { notify } from "../../../../util/helpers";
import PatientLoader from "../../../common/PatientLoader";
import {
  deletePateintAssessmentsLogic,
  fetchPateintAssessmentsLogic,
} from "../../../../store/features/patient/assessmentsSlice";
import PatientAssessmentModal from "../Assessments/PatientAssessmentModal";
import { NoAssessments } from "./FlaggedJournals";
import { gapDaysText } from "../../../../constants/constants";

const AssessmentItem = ({
  assessmentData,
  assessmentName,
  patientAssessments,
  setPatientAssessments,
  caregiverAssesments,
  setCaregiverAssessments,
  data,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [activeStatus, setActiveStatus] = useState(false);
  const [modalName, setModalName] = useState("Edit Assessment");
  const [singleAssessmentData, setSingleAssessmentData] = useState(null);
  function handleAssessmentAction(action) {
    setModalName("Edit Assessment");
    setModalOpen(true);
  }
  function handleDeleteAssessment(id) {
    deletePateintAssessmentsLogic(id)
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          //* Check if assessment being deleted is for caregiver or for child
          if (assessmentName.includes("Informant")) {
            const newCaregiverAssessments = caregiverAssesments.filter(
              (item) => item.id !== id
            );
            setCaregiverAssessments(newCaregiverAssessments);
          } else {
            const newPatientAssessments = patientAssessments.filter(
              (item) => item.id !== id
            );
            setPatientAssessments(newPatientAssessments);
          }
          notify("Assessment deleted successfully");
        } else {
          notify("Something went wrong", "error");
        }
      })
      .catch((err) => {
        notify("Something went wrong", "error");
        console.log("err", err);
      });
  }
  function getFrequencyText(gap_days) {
    return gapDaysText[gap_days] || `Every ${gap_days} days`;
  }

  useEffect(() => {
    const assessmentStatus = moment(
      moment(assessmentData?.end_date).format("MMM DD, YYYY")
    ).isAfter(moment(new Date()).format("MMM DD, YYYY"));
    setActiveStatus(assessmentStatus);
  }, [assessmentData]);

  return (
    <>
      <PatientAssessmentModal
        modalIsOpen={isModalOpen}
        setModalOpen={setModalOpen}
        assessment={assessmentData}
        assessmentName={assessmentName}
        patientId={assessmentData?.patient}
        modalName={modalName}
        data={data}
        setPatientAssessments={setPatientAssessments}
        setCaregiverAssessments={setCaregiverAssessments}
      />
      <tr
        className="py-3"
        style={{
          height: "4rem",
          verticalAlign: "middle",
        }}
      >
        <td>
          <small style={{ fontWeight: "500" }}>{assessmentName}</small>
        </td>
        {/* <td>
          <small style={{ fontWeight: "500" }}>
            {moment(assessmentData?.created).format("MMM DD, YYYY") ||
              "Not Available"}
          </small>
        </td> */}
        <td>
          <small style={{ fontWeight: "500" }}>
            {moment(assessmentData?.start_date).format("MMM DD, YYYY") ||
              "Not Available"}
          </small>
        </td>
        <td>
          <small style={{ fontWeight: "500" }}>
            {moment(assessmentData?.end_date).format("MMM DD, YYYY") ||
              "Not Available"}
          </small>
        </td>
        <td>
          <small style={{ fontWeight: "500" }}>
            {getFrequencyText(assessmentData?.gap_days)}
          </small>
        </td>
        <td>
          <small
            style={{
              fontWeight: "500",
              color: activeStatus ? "#008446" : "#9e1a11",
            }}
          >
            {(activeStatus ? "Active" : "Inactive") || "Not Available"}
          </small>
        </td>
        <td>
          <button
            className="btn transparent-btn"
            style={{ padding: "0px !important" }}
            onClick={() => {
              setModalOpen(true);
              handleAssessmentAction("edit");
              setSingleAssessmentData(assessmentData);
            }}
          >
            <PencilIcon />
          </button>
          <button
            className="btn transparent-btn"
            onClick={() => {
              handleDeleteAssessment(assessmentData?.id);
            }}
          >
            <TrashIcon />
          </button>
        </td>
      </tr>
    </>
  );
};
export const AssessmentsTable = ({
  assessmentData,
  patientAssessments,
  setPatientAssessments,
  caregiverAssessments,
  setCaregiverAssessments,
}) => {
  const [local_patientAssessments, setLocal_patientAssessments] = useState([]);
  const [local_caregiverAssessments, setLocal_caregiverAssessments] = useState(
    []
  );
  useEffect(() => {
    setLocal_patientAssessments([...patientAssessments]);
  }, [patientAssessments]);
  useEffect(() => {
    setLocal_caregiverAssessments([...caregiverAssessments]);
  }, [caregiverAssessments]);

  return (
    <table className="table my-3 px-2">
      <thead className="thead-light" style={{ backgroundColor: "#F9FAFB" }}>
        <tr
          style={{
            height: "4rem",
            verticalAlign: "middle",
          }}
        >
          <th scope="col">
            <span className="muted-text">Assessment Name</span>
          </th>
          {/* <th scope="col">
            <span className="muted-text">Schedule</span>
          </th> */}
          <th scope="col">
            <span className="muted-text">Start Date</span>
          </th>
          <th scope="col">
            <span className="muted-text">End Date</span>
          </th>
          <th scope="col">
            <span className="muted-text">Frequency</span>
          </th>
          <th scope="col">
            <span className="muted-text">Status</span>
          </th>
          <th scope="col">
            <span className="muted-text">Action</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {assessmentData.length > 0 &&
          assessmentData
            .filter((assessment) => {
              if (assessment !== undefined) {
                return assessment;
              }
            })
            .map((assessment) => {
              return (
                <AssessmentItem
                  assessmentData={assessment}
                  assessmentName={assessment?.assessment_name}
                  key={assessment?.id}
                  patientAssessments={local_patientAssessments}
                  caregiverAssesments={local_caregiverAssessments}
                  setCaregiverAssessments={setCaregiverAssessments}
                  setPatientAssessments={setPatientAssessments}
                  data={assessmentData}
                />
              );
            })}
      </tbody>
    </table>
  );
};

const PatientAssessment = (props) => {
  const [assD, setAssd] = useState([]);
  useEffect(() => {
    setAssd([...new Set([...props?.assessmentData])]);
  }, [
    props?.assessmentData,
    props?.patientAssessments,
    props?.caregiverAssesments,
  ]);

  return (
    <CardLayout
      className="col-sm-12 col-md-12 col-lg-12"
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      {props?.assessmentLoading || props?.patientAssessmentLoading ? (
        <PatientLoader />
      ) : (
        <div className="container-fluid p-4">
          <div className="d-flex justify-content-between mb-4 mt-2">
            <label style={{ fontSize: "1.3rem", display: "flex", gap: "10px" }}>
              <CalendarIcon /> Scheduled Assessments
            </label>
            <small
              onClick={() => {
                props.setAssessmentsTab();
              }}
              style={{
                color: "#395e9d",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            ></small>
          </div>
          {!assD || assD?.length === 0 ? (
            <NoAssessments text="No Scheduled Assessments" show_link={false} />
          ) : (
            <div
              className="container-fluid"
              style={{ height: "40vh", overflowY: "scroll" }}
            >
              <AssessmentsTable
                assessmentData={assD}
                patientAssessments={props?.patientAssessments}
                setPatientAssessments={props?.setPatientAssessments}
                caregiverAssessments={props?.caregiverAssesments}
                setCaregiverAssessments={props?.setCaregiverAssessments}
              />
            </div>
          )}
        </div>
      )}
    </CardLayout>
  );
};
export default PatientAssessment;
